export default __webpack_public_path__ + "static/media/add.cf18676f.svg";